<template>
  <div>
    <v-container class="mt-5">
      <lots-table :subdivisions="mappedSubdivisions" />
    </v-container>
    <v-container class="mt-5">
      <v-row>
        <v-col>
          <v-btn
            :loading="isLoading && clicked === 'data'"
            color="success"
            class="mx-2"
            @click="getData()"
          >
            Refresh data
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _cloneDeep from "lodash.clonedeep";
import LotsTable from "../components/lots/LotsTable.vue";

export default {
  components: {
    LotsTable,
  },
  data() {
    return {
      clicked: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.clicked = "data";
      this.$store.dispatch("getSubdivisions");
      this.$store.dispatch("getTeams");
      this.$store.dispatch("getUsers");
      this.$store.dispatch("getAdminCms");
      this.$store.dispatch("getPermissions");
    },
    sendNotifications() {
      this.clicked = "notifications";
      this.$store.dispatch("sendNotifications");
    },
  },
  computed: {
    ...mapGetters(["subdivisions", "teams", "isLoading", "users", "adminCms"]),
    mappedSubdivisions() {
      return _cloneDeep(this.subdivisions);
    },
  },
};
</script>
